import main from '@/locales/ru/main';
import custom from '@/locales/ru/custom';
import customers from '@/locales/ru/customers';
import refund from '@/locales/ru/refund';
import exchanges from '@/locales/ru/exchanges';
import issue from '@/locales/ru/issue';
import logs from '@/locales/ru/logs';
import refundExchange from '@/locales/ru/refundExchange';
import settings from '@/locales/ru/settings';
import tasks from '@/locales/ru/tasks';
import orders from '@/locales/ru/orders';
import products from '@/locales/ru/products';
import feedback from '@/locales/ru/feedback';
import errors from '@/locales/ru/errors';
import scanner from '@/locales/ru/scanner';
import alerts from '@/locales/ru/alerts';

export default {
    main,
    custom,
    customers,
    refund,
    exchanges,
    issue,
    logs,
    refundExchange,
    settings,
    tasks,
    orders,
    products,
    feedback,
    errors,
    scanner,
    alerts,
};